<template>
	<section class="concept-overlay-wrapper">
		<div class="row">
			<div :class="[columnClassesLeft]">
				<div v-for="(block, index) in data.overlay_text_right" :key="index" class="row text-image-row">
					<div class="columns small-6 medium-4">
						<div class="image-wrapper">
							<img :src="block.image.url" :alt="block.image.alt" />
						</div>
					</div>
					<div class="columns small-12 medium-8" v-html="block.text">
					</div>
				</div>
			</div>
			<div :class="[columnClassesRight]" v-html="data.overlay_text_left">
			</div>
		</div>
		<div class="overlay-nav-wrapper">
			<div class="row">
				<nav class="columns small-12 medium-8 medium-offset-2 large-10 large-offset-1">
					<a href="$t('intro_url')" v-text="$t('back_to_year_in_review')" class="back has-icon" v-on:click.prevent="closeOverlay"></a>
					<router-link :to="$t('home_url')" v-text="$t('continue_to_read_full_report')" class="next has-icon"></router-link>
				</nav>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: ['data'],
	data() {
		return {
			columnClassesLeft: 'columns small-12 medium-8 medium-offset-2 large-5 large-offset-1',
			columnClassesRight: 'columns small-12 medium-8 medium-offset-2 large-5 large-offset-0',
		}
	},
	methods: {
		closeOverlay() {
			document.getElementById('globalOverlayClose').click()
		}
	}
}
</script>